import { Component } from 'react'
import { Code, Period, CodeableConcept, CodeableConcepts, DispenseRequest, Annotations, Substitution, Dosages } from '../helpers'
import { FaPills } from 'react-icons/fa'
import moment from 'moment'

import './resource.css'

class MedicationRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaPills /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.intent && 'Intent'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.intent && Code(this.props.resource.intent)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Category'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>                        
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.statusReason && 'Reason'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.statusReason && CodeableConcept(this.props.resource.statusReason)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.priority && 'Priority'}</div>
                            <div className='Res-Title'>{this.props.resource.priority && Code(this.props.resource.priority)}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail'>{this.props.resource.reported && 'Reported'}</div>
                        </div>
                    </div>
                    {this.props.resource.authoredOn && <div className='Res-Row'>{moment(this.props.resource.authoredOn).format('lll')}</div>}
                    {this.props.resource.medicationCodeableConcept && <div className='Res-Row'>{CodeableConcept(this.props.resource.medicationCodeableConcept)}</div>}
                    {this.props.resource.dispenseRequest && <div className='Res-Row'>{DispenseRequest(this.props.resource.dispenseRequest)}</div>}
                    {this.props.resource.effectiveDosePeriod && <div className='Res-Row'>{Period(this.props.resource.effectiveDosePeriod)}</div>}
                    {this.props.resource.dosageInstruction && <div className='Res-Row'>{Dosages(this.props.resource.dosageInstruction)}</div>}
                    {this.props.resource.substitution && <div className='Res-Row'>{Substitution(this.props.resource.substitution)}</div>}
                    {this.props.resource.note && <div className='Res-Row'>{Annotations(this.props.resource.note)}</div>}
                </div>
            }
        </div></div>
    }
}

export default MedicationRequest